// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1zEyd","question":"Question_question__1vX_5","description":"Question_description__3Q-od"};